import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-messages-log',
  templateUrl: './messages-log.component.html',
  styleUrls: ['./messages-log.component.scss']
})
export class MessagesLogComponent implements OnInit {

  displayedColumns=[
    'number',
    // 'title',
    'subject',
    // 'message-type',
    // 'status',
    // 'recipient',
    'date',
    'action'
  ]
  outgoingMessageList:any
  pageSizeOptions:number[] = [
    20,
    50,
    100,
    200,
    500
  ];
  pageSize:number = this.pageSizeOptions[0];
  pageOffset: number = 0;
  pageIndex: number = 0;
  messageDetail:any;
  @ViewChild('outgoingMessageDetail',{static:false}) outgoingMessageDetail :any
  constructor(
    private notificationService :NotificationService,
    private dialog : MatDialog
  ) { }

  ngOnInit() {
    this.getOutgoingMessageList()
  }

  getOutgoingMessageList(reset:boolean=false){
    if(reset) {
      this.pageOffset = 0;
      this.pageIndex = 0;
    }
    let filters = { limit: this.pageSize, offset: this.pageOffset, ordering: '-id'};
    this.notificationService.getOutgoingMessageList(filters).subscribe(res=>{
      this.outgoingMessageList=res
    })
  }

  getMessageDetail(id){
    this.notificationService.getOutgoingMessageDetail(id).subscribe(data=>{
      this.messageDetail=data
      this.dialog.open(this.outgoingMessageDetail)
    })
  }

  onPaginationChange(e) {
    this.pageIndex = e.pageIndex;
    this.pageSize = e.pageSize;
    this.pageOffset = this.pageIndex * this.pageSize;
    this.getOutgoingMessageList()
  }

}
